<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Оказание неотложной помощи</h3>
            <p class="depth bullet03">Медицинское обслуживание неотложных пациентов (или рожениц) проводится круглосуточно, в том числе и в праздничные дни</p>
            <p class="depth bullet03">Чтобы быть готовыми к круглосуточному обслуживанию неотложных пациентов, мы обеспечены оборудованием для экстренной медицинской помощи и полностью укомплектованы специалистами. Мы постоянно стремимся быстро оказывать экстренную помощь.</p>

            <p class="depth bullet03">
                Неотложные пациенты немедленно получат медицинскую помощь в приемном отделении независимо от системы предоставления медицинских услуг (вне зависимости от посещения медицинского учреждения первичного или вторичного уровня) или их региона.
            </p>
            <p class="depth bullet03">В Центре экстренной медицинской помощи круглосуточно работает сеть беспроводной связи и оборудование для экстренной медицинской помощи, а также дежурят кареты скорой помощи, организовывая сеть экстренной медицинской помощи и сводя к минимуму промежутки в обслуживании в ночное время и праздничные дни.</p>
        </div>

        <div class="info">
            <h3 class="bullet01">Регистрация на получение экстренной помощи</h3>
            <p class="depth">после прибытия в приемное отделение пройдите предварительный медицинский осмотр на определение степени тяжести состояния, подайте заявку на обслуживание в административном отделении внутри приемного отделения и предъявите заявку на медицинское обслуживание, а также свой страховой полис (свидетельство медицинского страхования) вместе с ИД-картой.</p>
            <p class="depth">Как только администрация выдаст вам табличку неотложного пациента с вашим именем и браслет, передайте их сестринскому посту.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Оказание неотложной помощи</h3>
            <p class="depth">врач приемного отделения примет решение о том, выписать ли вас после лечения или госпитализировать.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Оплата экстренной медицинской помощи</h3>
            <p class="depth">
                медицинское обслуживание неотложного пациента производится немедленно после принятия решения о выписке. Однако специальные процедуры (МРТ, КТ, УЗИ) оплачиваются перед каждой процедурой. <br>
                Пациенты, чья медицинская страховка или страховое покрытие лечения не подтверждено, должны оплатить полную стоимость услуг. <br>
                Оплата может быть произведена кредитной картой.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Освобождение палаты и госпитализация</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width: 50%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Выписка</th>
                            <th>госпитализации</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                освободите палату и представьте квитанцию об оплате медсестре, чтобы перед отъездом получить лекарственные средства и информацию о вашей последующей схеме лечения и мерах предосторожности, предпринимаемых дома.
                            </td>
                            <td>
                                если вы подлежите госпитализации, дежурная медсестра поможет вам пройти регистрацию, после чего завершите процедуру госпитализации в окне регистрации/оплаты приемного отделения.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>